import heroBackground from "../source/academyDetail/background.png";
import solanaDexHero from "../source/academy/037ea9d79de1f654577096a5c117519f695e2f71.jpg";
import solanaDexCard from "../source/academy/41621fd23245fbca571f7094a0dbf548fa4dae52.jpg";
import dexNetwork from "../source/academy/2/image8.png";
import dexOrcaHome from "../source/academy/2/image1.png";
import dexConnectWallet from "../source/academy/2/image6.png";
import dexApproveConnection from "../source/academy/2/image5.png";
import dexWalletConnected from "../source/academy/2/image3.png";
import dexTrade from "../source/academy/2/image7.png";
import dexSolscan from "../source/academy/2/image4.png";
import dexDisconnect from "../source/academy/2/image2.png";
import solanaOverview from "../source/academy/solana-beginner/solana-overview.png";
import solanaBeginnerOverview from "../source/academy/1/image8.png";
import solanaFirstTransaction from "../source/academy/1/image2.png";
import metamaskDownload from "../source/academy/1/image3.png";
import metamaskSetupOptions from "../source/academy/1/image1.png";
import metamaskRecoveryPhrase from "../source/academy/1/image7.png";
import metamaskWalletSettings from "../source/academy/1/image12.png";
import metamaskSolanaNetwork from "../source/academy/1/image6.png";
import metamaskAddFunds from "../source/academy/1/image4.png";
import metamaskTokenMarketplace from "../source/academy/1/image11.png";
import metamaskReceiveCrypto from "../source/academy/1/image10.png";
import metamaskTransferCrypto from "../source/academy/1/image5.png";
import ledgerLiveDownload from "../source/academy/1/image9.png";
import ledgerLiveGetStarted from "../source/academy/1/image13.png";
import phantomDownload from "../source/academy/3/image1.png";
import phantomSetup from "../source/academy/3/image2.png";
import phantomHome from "../source/academy/3/image3.png";
import phantomBuySol from "../source/academy/3/image4.png";
import phantomReceive from "../source/academy/3/image5.png";
import phantomSend from "../source/academy/3/image6.png";
import phantomConnect from "../source/academy/3/image7.png";
import phantomConfirm from "../source/academy/3/image8.png";
import phantomSecurity from "../source/academy/3/image9.jpeg";
import solflareDownload from "../source/academy/4/image2.png";
import solflareHero from "../source/academy/4/image3.png";
import solflareCreateWallet from "../source/academy/4/image7.png";
import solflareRecoveryPhrase from "../source/academy/4/image8.png";
import solflareReceive from "../source/academy/4/image4.png";
import solflareBuyCrypto from "../source/academy/4/image1.png";
import solflareStaking from "../source/academy/4/image5.png";
import solflareFeatures from "../source/academy/4/image6.png";
import solflareHeroBanner from "../source/academy/4/solflare-hero.svg";

const defaultSections = [
  {
    title: "Introduction",
    paragraphs: [
      "More academy content is coming soon. Check back for fresh lessons and walkthroughs.",
    ],
  },
];

const baseArticles = [
  {
    id: 1,
    difficulty: "Easy",
    title:
      "Solana Beginner Tutorial (2026): Wallets, DEXs, Staking, First Steps & Safety",
    text: "Get into crypto in 2026 with this step-by-step Solana beginner tutorial: learn key blockchain concepts, how to set up wallets, and discover key safety rules.",
    detailSubtitle:
      "Get into crypto in 2026 with this step-by-step Solana beginner tutorial: learn key blockchain concepts, how to set up wallets, and discover key safety rules.",
    image: solanaOverview,
    heroImage: solanaOverview,
    time: "12 min",
    date: "2026-02-09",
    categories: ["Blockchain", "Wallets", "Staking", "Security"],
    sections: [
      {
        title: "Solana Beginner: Key Takeaways",
        list: [
          "Solana (SOL) is great for beginners: fast, low-fee, and easy to use.",
          "Wallets: store your tokens securely and manage private keys safely.",
          "DEXs vs CEXs: centralized exchanges for convenience; decentralized for full control.",
          "Safety first: protect your seed phrase, avoid fake apps, and don't chase FOMO projects.",
        ],
      },
      {
        title: "Introduction",
        paragraphs: [
          "What started as an obscure cryptography experiment in 2008 has become a staple of modern digital finance.",
          "As conventional savings accounts no longer offer meaningful returns, more and more people are turning to cryptocurrencies.",
          "This isn't a fringe movement. In 2026, about 30% of Americans own crypto, and over half of them report profits. That means you don't need technical skills or a large budget to start successfully.",
          "For beginners, Solana (SOL) is a smart choice: fast, affordable, and designed for everyday users, not just tech wizards.",
          "In this Solana beginner tutorial, you'll learn crypto basics, how to set up your first wallet, where and how to trade, and how to start exploring decentralized finance. By the end, you'll be ready to take your first steps and learn as you go.",
        ],
      },
      {
        title: "Crypto 101: blockchain, Bitcoin, and beyond",
        paragraphs: [
          "You've heard the terms: crypto, Bitcoin, blockchain, but what do they actually mean?",
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Cryptocurrency</strong> is a digital asset stored on a{" "}
                blockchain, a secure, shared ledger that records all
                transactions transparently. Instead of relying on banks or
                governments, decentralized networks maintain blockchains
                worldwide.
              </>
            ),
          },
          {
            content: (
              <>
                To use crypto, you need a <strong>wallet</strong>, which acts
                like your personal account. We'll cover wallets in detail
                shortly.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Bitcoin</strong> remains the dominant cryptocurrency. In{" "}
                2026, 74% of crypto users own Bitcoin, largely because it
                excels as a long-term store of value.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Solana</strong>, by contrast, focuses on usability.
                Growing in popularity since 2024, Solana is now the choice of{" "}
                <strong>20% users</strong> who enjoy its near-instant
                transactions, low fees, and support for everyday apps.
              </>
            ),
          },
        ],
        tailParagraphs: [
          <>
            <strong>In short:</strong> Bitcoin stores value, while Solana powers
            everyday use. That's why many users keep both.
          </>,
        ],
      },
      {
        title: "Solana beginner concepts you need to know",
        paragraphs: [
          "If you're new to Solana, fret not. A few core ideas will help you start confidently:",
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Solana</strong> is a blockchain that records and
                confirms transactions on a public ledger.
              </>
            ),
          },
          {
            content: (
              <>
                It has <strong>tokens</strong>: digital assets used for
                payments, staking rewards, or governance. Solana's native token
                is <strong>SOL</strong>, but the network supports thousands of
                others.
              </>
            ),
          },
          {
            content: (
              <>
                You access tokens through a <strong>wallet</strong>, which
                stores your private keys: the credentials that prove ownership.
              </>
            ),
          },
          {
            content: (
              <>
                Finally, <strong>validators</strong> are computers that process
                transactions and secure the network. With over 1,000 validators
                worldwide, Solana remains decentralized, reliable, and
                censorship-resistant.
              </>
            ),
          },
        ],
      },
      {
        title: "Why is Solana great for crypto beginners?",
        paragraphs: ["The key reasons crypto beginners choose Solana:"],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Speed &amp; low fees:</strong> Thousands of transactions
                per second; fees &lt; $0.01.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Accessibility:</strong> Anyone with internet access can
                use it—no bank account or credit check required.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Beginner-friendly:</strong> Designed for everyday users,
                not developers.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Safe sandbox:</strong> Solana is ideal for experimenting
                with small amounts and learning quickly.
              </>
            ),
          },
        ],
      },
      {
        title: "What can you do with Solana?",
        paragraphs: ["Even as a complete Solana beginner, you can:"],
        listVariant: "body",
        list: [
          { content: "Send money globally in seconds;" },
          { content: "Trade digital assets;" },
          { content: "Collect NFTs and digital art;" },
          { content: "Play blockchain-based games;" },
          { content: "Earn yield via staking or DeFi apps;" },
          { content: "Join communities built around shared interests." },
        ],
        media: [
          {
            type: "image",
            src: solanaBeginnerOverview,
            alt: "Solana ecosystem overview",
          },
          {
            type: "video",
            src: "https://www.youtube.com/embed/GZ-bYOCMfmE?si=Jvx1Y_45EK5MU_nL",
            title: "Solana beginner overview",
          },
        ],
        tailParagraphs: [
          <>
            <strong>Embed:</strong>{" "}
            <a
              href="https://youtu.be/GZ-bYOCMfmE?si=Jvx1Y_45EK5MU_nL"
              target="_blank"
              rel="noreferrer"
            >
              https://youtu.be/GZ-bYOCMfmE?si=Jvx1Y_45EK5MU_nL
            </a>
          </>,
        ],
      },
      {
        title: "DEXs and CEXs: Solana beginner explanation",
        paragraphs: [
          "When trading crypto, you'll encounter two platform types:"
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Centralized Exchanges (CEXs)</strong> like Coinbase or
                Binance require accounts and identity verification. They're
                convenient but hold custody of your funds.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Decentralized Exchanges (DEXs)</strong> on Solana like
                Raydium or Orca, let you trade directly from your wallet. No
                registration, no intermediaries, and full control of your
                assets.
              </>
            ),
          },
        ],
        callout: {
          variant: "outline",
          align: "center",
          content: (
            <>
              <strong>CEXs vs DEXs in short:</strong>
              <ul>
                <li>
                  <strong>DEXs</strong> equal freedom, but at the price of
                  responsibility. Irreversible transactions mean that security
                  is completely up to you.
                </li>
                <li>
                  <strong>CEXs</strong> are good for beginners to buy SOL, and
                  then move it to a wallet to explore DEXs safely.
                </li>
              </ul>
            </>
          ),
        },
      },
      {
        title: "3 steps to get started on Solana",
        ordered: true,
        listVariant: "steps",
        list: [
          {
            title: "Set up a wallet",
            details: [
              {
                text: "Wallets are free apps you can install in minutes. They store your keys and let you interact with the network.",
              },
            ],
          },
          {
            title: "Get some SOL",
            details: [
              {
                text: "SOL, Solana's native token SOL, is what you need to start exploring the network. Just a tiny amount is enough to cover transaction fees and experiment with a few transactions.",
              },
            ],
          },
          {
            title: "Make your first transaction",
            details: [
              {
                text: "Send SOL, swap tokens on a DEX, or try a Solana app. Transactions confirm in seconds, making it easy to learn safely.",
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: solanaFirstTransaction,
                  alt: "Your first steps on Solana",
                },
              },
            ],
          },
        ],
      },
      {
        title: "Solana beginner guide: How to set up your first wallet?",
        paragraphs: [
          "Your wallet is the most important tool in crypto. It's the software that lets you access the Solana network, manage your tokens, and interact with apps.",
          {
            text: "Think of a wallet as three things in one:",
            variant: "underline",
          },
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>A password manager</strong> that stores your private
                keys;
              </>
            ),
          },
          {
            content: (
              <>
                <strong>A bank account viewer</strong> that shows your balances;
              </>
            ),
          },
          {
            content: (
              <>
                <strong>A digital signature tool</strong> that approves
                transactions.
              </>
            ),
          },
        ],
      },
      {
        title: "What are the key Solana wallet types?",
        paragraphs: ["There are two main wallet categories:"],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Software wallets</strong>: Browser extensions, mobile
                apps, or desktop apps. These are quick to set up and ideal for
                beginners.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Hardware wallets</strong>: Physical devices that store
                keys offline, offering maximum security.
              </>
            ),
          },
        ],
        tailParagraphs: [
          {
            text: "Within those categories, you'll often hear of:",
            variant: "underline",
          },
          {
            variant: "block",
            content: (
              <ul className="academy-detail-block__list academy-detail-block__list--body">
                <li>
                  <strong>Hot wallets</strong> (e.g. MetaMask, Phantom):
                  Connected to the internet and best for small amounts and daily
                  use.
                </li>
                <li>
                  <strong>Cold wallets</strong> (e.g. Ledger): Offline storage
                  designed for long-term security.
                </li>
              </ul>
            ),
          },
          "Below, we'll walk through how to set up both.",
        ],
      },
      {
        title: "How to set up a hot wallet (MetaMask)",
        paragraphs: [
          "MetaMask is one of the most popular wallets and enables Solana access through its interface.",
        ],
        ordered: true,
        listVariant: "steps",
        list: [
          {
            title: "Download MetaMask",
            details: [
              {
                text: "Visit MetaMask's official website and download the wallet for your platform (browser extension, mobile app, or web app). Verify URLs to avoid scam or phishing.",
                media: {
                  type: "image",
                  src: metamaskDownload,
                  alt: "MetaMask download screen",
                },
              },
              {
                variant: "block",
                content: "Install the app and select Create a new wallet.",
              },
            ],
          },
          {
            title: "Choose your setup and recovery option",
            details: [
              {
                variant: "block",
                content: "MetaMask offers two setup options:",
              },
              {
                text: "Sign in using Google or Apple",
              },
              {
                text: "Create a wallet using a Secret Recovery Phrase (SRP)",
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: metamaskSetupOptions,
                  alt: "MetaMask setup options",
                },
              },
              {
                variant: "block",
                content:
                  "Using an SRP gives you full control without sharing personal information like email. Choose this option if privacy matters to you. You'll receive a list of recovery words: this is your only backup.",
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: metamaskRecoveryPhrase,
                  alt: "MetaMask recovery phrase prompt",
                },
              },
              {
                variant: "block",
                content: (
                  <div className="academy-detail-callout academy-detail-callout--warn academy-detail-callout--center">
                    <span className="academy-detail-callout__icon">
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path
                          d="M12 3.8l8.2 15H3.8l8.2-15z"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.6"
                          strokeLinejoin="round"
                        />
                        <line
                          x1="12"
                          y1="9"
                          x2="12"
                          y2="13.5"
                          stroke="currentColor"
                          strokeWidth="1.6"
                          strokeLinecap="round"
                        />
                        <circle cx="12" cy="17.2" r="1" fill="currentColor" />
                      </svg>
                    </span>
                    <div className="academy-detail-callout__text">
                      <strong>Important!</strong> Write your recovery phrase on
                      paper and store it offline. Never take screenshots or save
                      it digitally. If you lose it, or someone else captures it,
                      your assets may be gone forever! MetaMask will not be able
                      to recover your credentials.
                    </div>
                  </div>
                ),
              },
            ],
          },
          {
            title: "Set a password",
            details: [
              {
                text: "Choose a strong password to protect access to the wallet on your device. This password does not replace your recovery phrase, it only protects local access.",
              },
            ],
          },
          {
            title: "Finalize your wallet setup",
            details: [
              {
                text: "Once inside MetaMask, take a moment to: Name your wallet; Review network settings; Set your preferred currency.",
                media: {
                  type: "image",
                  src: metamaskWalletSettings,
                  alt: "MetaMask wallet settings",
                },
              },
              {
                text: "You can see that Solana is available as a default network:",
                media: {
                  type: "image",
                  src: metamaskSolanaNetwork,
                  alt: "Solana network in MetaMask",
                },
              },
            ],
          },
          {
            title:
              "Add funds to get ready to start buying, swapping, sending, and receiving SOL.",
            details: [
              {
                text: "Add funds gives you access to different ways to bring SOL into your wallet:",
                media: {
                  type: "image",
                  src: metamaskAddFunds,
                  alt: "Add funds in MetaMask",
                },
              },
              {
                variant: "block",
                content: (
                  <p className="academy-detail-block__step-paragraph">
                    <strong>a) Token Marketplace</strong> lets you use your
                    debit or credit card to securely pay for your chosen Solana
                    token:
                  </p>
                ),
                media: {
                  type: "image",
                  src: metamaskTokenMarketplace,
                  alt: "MetaMask token marketplace",
                },
              },
              {
                variant: "block",
                content: (
                  <p className="academy-detail-block__step-paragraph">
                    <strong>b) Receive Crypto</strong> gives you a list of
                    wallet addresses and QR codes you can use to receive tokens
                    and collectibles on Solana:
                  </p>
                ),
                media: {
                  type: "image",
                  src: metamaskReceiveCrypto,
                  alt: "Receive crypto in MetaMask",
                },
              },
              {
                variant: "block",
                content: (
                  <p className="academy-detail-block__step-paragraph">
                    <strong>c) Transfer crypto</strong> enables you to transfer
                    crypto directly to your wallet for free from CEXs like
                    Coinbase and Binance:
                  </p>
                ),
                media: {
                  type: "image",
                  src: metamaskTransferCrypto,
                  alt: "Transfer crypto in MetaMask",
                },
              },
            ],
          },
        ],
        tailParagraphs: [
          "Using MetaMask is similar to modern banking apps; the difference is that you control the assets, not a company.",
        ],
      },
      {
        title: "How to add Solana to Ledger Wallet (cold wallet)",
        paragraphs: [
          "Ledger wallet keeps your crypto secure by storing your private keys offline. While the app shows your balances, the physical device protects and signs transactions.",
        ],
        ordered: true,
        listVariant: "steps",
        list: [
          {
            title: "Download Ledger Live",
            details: [
              {
                variant: "block",
                content:
                  "Download Ledger Live to your desktop or mobile from the official website. Ledger Live is the companion app you'll use to manage accounts, install apps, and view your portfolio.",
                media: {
                  type: "image",
                  src: ledgerLiveDownload,
                  alt: "Ledger Live download",
                },
              },
              {
                variant: "block",
                content: 'Once installed, open the app and choose "Get Started."',
                media: {
                  type: "image",
                  src: ledgerLiveGetStarted,
                  alt: "Ledger Live get started",
                },
              },
            ],
          },
          {
            title: "Set up your Ledger device",
            details: [
              {
                variant: "block",
                content:
                  'Connect your Ledger device to your computer or phone and select "Set up as new device." You\'ll create a PIN code directly on the device and receive a 24-word recovery phrase.',
              },
              {
                variant: "block",
                content: (
                  <div className="academy-detail-callout academy-detail-callout--outline academy-detail-callout--center">
                    <span className="academy-detail-callout__icon">
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path
                          d="M12 3.8l8.2 15H3.8l8.2-15z"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.6"
                          strokeLinejoin="round"
                        />
                        <line
                          x1="12"
                          y1="9"
                          x2="12"
                          y2="13.5"
                          stroke="currentColor"
                          strokeWidth="1.6"
                          strokeLinecap="round"
                        />
                        <circle cx="12" cy="17.2" r="1" fill="currentColor" />
                      </svg>
                    </span>
                    <div className="academy-detail-callout__text">
                      <strong>This recovery phrase is critical!</strong> Write
                      it down on paper and store it offline. Never take
                      screenshots or store it digitally. Anyone with this
                      phrase can access your funds.
                    </div>
                  </div>
                ),
              },
            ],
          },
          {
            title: "Install the Solana App",
            details: [
              {
                variant: "block",
                content:
                  "In the Ledger Live app, go to Manager, enable the connection on your device, and search for Solana. Install the Solana app to allow your Ledger to interact with the Solana blockchain.",
              },
            ],
          },
          {
            title: "Add a Solana Account",
            details: [
              {
                variant: "block",
                content:
                  "Go to Accounts → Add account, select Solana, and confirm on your Ledger device. Ledger Live will create a Solana account linked to your hardware wallet.",
              },
            ],
          },
          {
            title: "Receive SOL",
            details: [
              {
                variant: "block",
                content:
                  "Your Solana wallet is now ready: you can use it to receive SOL by copying the wallet address from Ledger Live and sending a small amount to it.",
              },
            ],
          },
        ],
      },
      {
        title:
          "Next steps on Solana: buy-and-hold, staking, and trading on Solana DEXs",
        paragraphs: [
          <>
            Once you're comfortable using a wallet to{" "}
            <a href="#solana-beginner-guide-how-to-set-up-your-first-wallet">
              send and receive SOL
            </a>
            , you can start exploring Solana without unnecessary risks. Here
            are some of the most accessible options:
          </>,
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Buy-and-hold SOL:</strong> Purchase SOL via a
                centralized exchange or directly in wallets like MetaMask or
                Phantom, then hold it as you learn the ecosystem.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Staking SOL:</strong> Delegate your SOL to a validator
                to help secure the network and earn ~5–7% annual rewards (2026).
                Your SOL stays in your wallet, you retain ownership, and rewards
                accumulate automatically, making it a safe way to earn as you
                learn.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Swap tokens on decentralized exchanges</strong> like
                Raydium or Orca: This isn't day trading, but a practical way to
                learn how transactions work and understand token prices.
              </>
            ),
          },
        ],
        tailParagraphs: [
          "We'll dive deeper into Solana DEXs in the next article. For now, remember: start small, treat each step as learning, and avoid risky all-in bets.",
        ],
      },
      {
        title: "Safety for Solana beginners",
        paragraphs: [
          <>
            Solana is beginner-friendly, but smart habits pay off, especially
            when it comes to{" "}
            <a href="#safety-for-solana-beginners">security</a>:
          </>,
        ],
        ordered: true,
        listVariant: "steps",
        list: [
          {
            title: "Avoid losing your seed phrase or private keys.",
            details: [
              {
                variant: "block",
                content:
                  "If you lose them, you lose access to your funds permanently. Write them on paper, and store them offline in different places. And, of course, never share them with anyone!",
              },
            ],
          },
          {
            title: "Be cautious about fake wallets and phishing websites.",
            details: [
              {
                variant: "block",
                content:
                  "Download Solana wallets only from official websites and trusted app stores, and double-check links before clicking.",
              },
            ],
          },
          {
            title: "Be cautious of schemes and influencers promising quick profits.",
            details: [
              {
                variant: "block",
                content:
                  "Crypto rewards patience and learning, not hype. Likewise, avoid panicking during price dips. Short-term volatility is normal.",
              },
            ],
          },
        ],
        tailParagraphs: [
          "Finally, steer clear of risky moves like leverage trading, going all-in, or chasing FOMO projects. Solana rewards steady learning, not rushed decisions.",
        ],
      },
      {
        title: "Solana beginner journey: from curious to confident",
        paragraphs: [
          "Solana's speed, low fees, and beginner-focused design make it perfect for newcomers. But crypto is a tool, and success depends on how you use it.",
          "Start by securing a wallet, adding some SOL, and completing a few basic transactions. Once comfortable, you can explore decentralized exchanges, and staking, all while learning safely and confidently.",
          "That's exactly what the next article in our Solana Beginner Guide series will cover: a practical, hands-on look at Solana DEXs and how to use them confidently.",
          "The next move is yours: set up your wallet, send a small amount of SOL, and make your first transaction. Learning by doing is the fastest way to gain confidence. Are you in?",
        ],
      },
      {
        title: "Solana Beginner FAQ:",
        type: "faq",
        items: [
          {
            question: "Why is Solana great for crypto newcomers?",
            answer:
              "Solana is fast, low-fee, and beginner-friendly, letting you explore crypto safely with small amounts.",
          },
          {
            question: "What is the best wallet for a Solana beginner?",
            answer:
              "Hot wallets like MetaMask or Phantom are great for daily use, while cold wallets like Ledger offer long-term security. Many users combine both.",
          },
          {
            question: "Should a Solana beginner start with a CEX or DEX?",
            answer:
              "Beginners often buy SOL on a CEX for convenience, then transfer it to a wallet to explore DEXs safely and keep full control.",
          },
          {
            question: "How can a Solana beginner earn rewards?",
            answer:
              "Stake SOL with validators, hold SOL or top tokens, or practice swapping tokens on DEXs.",
          },
          {
            question: "What mistakes should Solana beginners avoid?",
            answer:
              "Losing seed phrases, using fake wallets, trusting influencers blindly, panicking during dips, or chasing FOMO projects.",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    difficulty: "Easy",
    title: "Best Solana DEX in 2026: Beginner Guide, Tutorial & Safety Tips",
    text: "Looking to get into crypto in 2026? Learn how Solana DEXs work, compare top platforms like Jupiter and Orca, and trade safely step by step.",
    detailSubtitle:
      "Learn how Solana DEXs work, compare top platforms like Jupiter and Orca, and trade safely with a step-by-step tutorial.",
    image: solanaDexCard,
    heroImage: solanaDexHero,
    time: "10 min",
    date: "2026-02-12",
    categories: ["Blockchain", "Fees", "Wallets", "Security"],
    sections: [
      {
        title: "Solana DEXs: key takeaways",
        list: [
          "Trade directly from your wallet with no extra accounts or intermediaries.",
          "Fast and low-cost: transactions settle in seconds with fees under a cent.",
          "Self-custody: you remain in full control of your funds at all times.",
          "Start simple: begin with beginner-friendly platforms like Orca or Jupiter before exploring advanced tools.",
          "Stay safe: use official sites, double-check URLs, and avoid hype tokens or risky swaps.",
        ],
      },
      {
        title: "Introduction",
        paragraphs: [
          "Imagine trying to complete an online purchase where checkout takes minutes, and the fees cost more than the product. That is what trading crypto on some networks often feels like, until you discover Solana.",
          "As you learned in our previous beginner guide, Solana was designed to process thousands of transactions per second while keeping fees minimal. Transactions on Solana cost an average of $0.00025 and settle almost instantly. On networks like Ethereum Mainnet, fees can spike (sometimes exceeding $50), and confirmations slow during peak congestion.",
          "In the previous guide, you set up your MetaMask wallet for Solana. Now comes the exciting part: using it to trade on decentralized exchanges (DEXs). Solana DEXs let you swap tokens directly from your wallet, without extra accounts or intermediaries.",
          "Even beginners can trade confidently with just a few clicks. Let's explore why Solana DEXs are such a game changer and how to get started.",
        ],
      },
      {
        title: "What is a Solana DEX?",
        paragraphs: [
          "A DEX is a decentralized exchange: a platform that lets you swap crypto directly from your wallet without giving control of your funds to a third party.",
          "On a centralized exchange (CEX) like Binance or Coinbase, you deposit crypto into the platform's custody. The company controls your assets, and you access them through an account secured by email and password.",
          "A DEX works the opposite way. You do not create an account or deposit funds. You connect your wallet, choose the tokens you want to swap, confirm the transaction, and the trade happens directly on the blockchain.",
          "Your wallet is your account. You keep control of your private keys at all times, and the platform never holds your funds. It only facilitates the swap using smart contracts.",
        ],
      },
      {
        title: "What makes Solana DEXs unique?",
        paragraphs: [
          "Solana DEXs are an excellent choice for crypto beginners because they combine performance, affordability, and reliability:",
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Instant transactions:</strong> Trades settle in seconds,
                making trading feel like sending a WhatsApp message rather than
                posting a letter.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Minimal costs:</strong> Trading often costs less than a
                cent, so you can experiment without worrying about fees.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Dependable execution:</strong> Parallel processing
                keeps transactions from getting stuck or failing, a common issue
                on other networks.
              </>
            ),
          },
        ],
        tailParagraphs: [
          "All these features create a smooth experience for crypto newcomers. You can explore tokens, try out trades, and practice strategies confidently, without long waits or hidden costs.",
          <strong key="dexs-confidence">
            Solana DEXs make it easy for beginners to start trading on-chain
            with confidence.
          </strong>,
          "But before you start swapping tokens, it helps to understand a few key ideas. Don’t worry, they’re simpler than they sound:",
        ],
      },
      {
        title: "Core Solana DEX concept for beginners",
        ordered: true,
        listVariant: "concept",
        list: [
          {
            title: "Self-custody",
            paragraphs: [
              <>
                <strong>
                  Your wallet is both your account and your vault.
                </strong>{" "}
                There's no bank, no exchange, and no customer support holding
                your crypto.
              </>,
              <>
                At the end of the day it's DeFi: decentralized finance, a
                system enabling users to conduct transactions directly without
                intermediaries. Only you control your private keys. This means
                only you can access your funds, so it's a bit like carrying your
                own digital safe in your pocket.
              </>,
            ],
          },
          {
            title: "Liquidity",
            paragraphs: [
              <>
                <strong>
                  Liquidity refers to how much of a token is available for
                  trading.
                </strong>{" "}
                The more liquidity there is, the easier it is to buy or sell
                without affecting the price.
              </>,
              <>
                Imagine a busy marketplace with lots of buyers and sellers:
                prices stay stable. But in a nearly empty market, a larger
                purchase (let's say about $1,000 instead of $10) can impact the
                price noticeably.
              </>,
            ],
          },
          {
            title: "Slippage",
            paragraphs: [
              <>
                <strong>
                  Slippage is the difference between the price you expect to
                  pay and the price you actually receive when your trade
                  executes.
                </strong>{" "}
                It can happen when the market moves between the moment you
                submit a transaction and the moment it's confirmed, especially
                if liquidity is low or the network gets congested.
              </>,
              <>
                On fast, high-liquidity networks like Solana, slippage is often
                lower because trades execute quickly and there are typically
                more buyers and sellers in the market.
              </>,
            ],
          },
          {
            title: "Fees",
            paragraphs: [
              <>
                <strong>
                  On Solana, network fees are low, usually just fractions of a
                  cent.
                </strong>{" "}
                DEX trading fees also typically stay below 1%, making the
                ecosystem an affordable playground for beginners to learn
                without worrying about high costs.
              </>,
            ],
          },
        ],
      },
      {
        title: "Choosing your first Solana DEX",
        paragraphs: [
          "Now that you're aware of the key concepts, the next step is choosing the right DEX for your needs.",
          "Solana offers several strong options, each designed for slightly different users. Some of the most popular Solana DEXs include Jupiter, Orca, Raydium, and Drift.",
          "Although they all enable swapping tokens, they serve different purposes, and it's beneficial to be aware of these differences.",
          {
            text: "Broadly speaking, Solana DEXs fall into three categories:",
            variant: "underline",
          },
        ],
        ordered: true,
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Swap aggregators:</strong> Platforms like Jupiter scan
                multiple DEXs to automatically find you the best available
                price. For beginners, this can be a great default choice because
                it removes the guesswork.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Simple swap DEXs:</strong> Orca is known for its clean,
                beginner-friendly interface and straightforward swapping
                experience.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Advanced trading platforms:</strong> Raydium and Drift
                come with more advanced tools like{" "}
                <a
                  href="https://academy.binance.com/en/articles/liquidity-pool"
                  target="_blank"
                  rel="noreferrer"
                >
                  liquidity provision
                </a>{" "}
                or{" "}
                <a
                  href="https://www.coinbase.com/learn/crypto-basics/what-are-perpetual-futures"
                  target="_blank"
                  rel="noreferrer"
                >
                  perpetual futures
                </a>
                . These features become an interesting continuation of your
                learning process once you become comfortable with basic swaps.
              </>
            ),
          },
        ],
      },
      {
        title: "How popular Solana DEXs compare",
        type: "table",
        columns: ["DEX", "Best for", "Skills required", "Key strengths"],
        rows: [
          ["Orca", "Simple swaps", "Beginner", "Clean, intuitive interface"],
          [
            "Jupiter",
            "Price routing and comparison",
            "Beginner",
            "Aggregates liquidity automatically",
          ],
          [
            "Raydium",
            "Advanced tools",
            "Intermediate",
            "Liquidity pools and yield",
          ],
          [
            "Drift",
            "Perpetual futures",
            "Advanced",
            "Advanced trading strategies",
          ],
        ],
      },
      {
        title: "Choosing your first Solana DEX: checklist",
        paragraphs: [
          {
            text: "There are many competitive Solana DEXs, so when choosing your first Solana DEX, keep this checklist in mind:",
            variant: "highlight",
          },
        ],
        listVariant: "checklist",
        list: [
          { content: "User-friendly interface." },
          { content: "Works with your wallet (MetaMask, Phantom, Solflare)." },
          {
            content:
              "Supports popular tokens like SOL, but also stablecoins like USDC, and USDT.",
          },
          { content: "Low trading fees." },
          { content: "Strong reputation and solid security track record." },
        ],
        tailParagraphs: [
          {
            text: "For starters, remember that simplicity beats advanced features.",
            variant: "strong",
          },
          "Start with a platform that feels safe and intuitive. There will be time for more sophisticated tools as your confidence grows.",
        ],
      },
      {
        title: "Tutorial: connecting your wallet to a Solana DEX",
        paragraphs: [
          "In the previous tutorial, we showed you how to set up your first hot wallet (MetaMask). Now it's time to start using it for token swaps on Solana DEXs.",
        ],
        ordered: true,
        listVariant: "steps",
        list: [
          {
            title: "Switch MetaMask to the Solana Network",
            details: [
              {
                text: "Open MetaMask → Networks → Choose Solana on the list of managed networks. The confirmed network is active and the SOL balance is visible.",
                media: {
                  type: "image",
                  src: dexNetwork,
                  alt: "MetaMask Solana network selection",
                },
              },
            ],
          },
          {
            title: "Visit a Solana DEX",
            details: [
              {
                text: "For this tutorial, we chose Orca, which is known for its user-friendly interface. Before connecting your wallet, please verify the URL is official.",
                media: {
                  type: "image",
                  src: dexOrcaHome,
                  alt: "Orca DEX homepage",
                },
              },
            ],
          },
          {
            title: "Connect your wallet",
            details: [
              {
                text: "Click “Connect Wallet” and select MetaMask.",
                media: {
                  type: "image",
                  src: dexConnectWallet,
                  alt: "Connect wallet modal",
                },
              },
            ],
          },
          {
            title: "Approve connection in MetaMask",
            details: [
              {
                text: "Approve the connection request in MetaMask.",
                media: {
                  type: "image",
                  src: dexApproveConnection,
                  alt: "Approve connection in MetaMask",
                },
              },
            ],
          },
          {
            title: "Ensure your wallet appears on the DEX",
            details: [
              {
                text: "Confirm your wallet address appears in the DEX interface.",
                media: {
                  type: "image",
                  src: dexWalletConnected,
                  alt: "Wallet connected on Orca",
                },
              },
            ],
          },
          {
            title: "Execute your first swap",
            details: [
              {
                text: "Go to Trade, and select your input token such as SOL, and your output token, e.g. USDC).",
              },
              {
                text: "Enter amount, review quote, fees, slippage. Make sure you have enough balance to make this purchase.",
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: dexTrade,
                  alt: "Swap tokens on Orca",
                },
              },
              {
                text: "Click “Trade” and confirm your selection in MetaMask. Your transaction will be completed within a few seconds.",
              },
            ],
          },
          {
            title: "Verify the transaction",
            details: [
              {
                text: "Check that your wallet balance updated correctly. Optionally, verify your transaction on Solscan by pasting the transaction ID into the search bar.",
                media: {
                  type: "image",
                  src: dexSolscan,
                  alt: "Verify transaction on Solscan",
                },
              },
            ],
          },
          {
            title: "Disconnect your wallet",
            details: [
              {
                text: "Disconnect your wallet from the DEX for security.",
                media: {
                  type: "image",
                  src: dexDisconnect,
                  alt: "Disconnect wallet from Orca",
                },
              },
            ],
          },
        ],
      },
      {
        title: "Staying safe on Solana DEXs",
        paragraphs: [
          "Trading on a Solana DEX gives you freedom, but it also comes with responsibility. You remain in full control of your wallet, so you are responsible for protecting it.",
          "Here are a few essential safety habits:",
        ],
        ordered: true,
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Use official websites only.</strong> Always double-check
                URLs and bookmark trusted DEX sites like Jupiter or Orca.
                Phishing scams are rife in crypto, so you can never be too
                careful.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>
                  Make sure you have enough balance to complete your purchase.
                </strong>{" "}
                This includes both the token amount you are swapping and a
                small amount of SOL to cover network fees. Failed transactions
                can happen if your wallet balance is too low.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Steer away from hype tokens.</strong> If a token is
                trending aggressively on social media, take a moment to
                research it. Many scams rely on urgency and FOMO.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Consider getting a hardware wallet.</strong> For larger
                balances, a hardware wallet like{" "}
                <a
                  href="https://www.ledger.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  Ledger
                </a>{" "}
                can add an extra layer of protection by keeping your private
                keys offline.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Verify transactions on </strong>
                <a
                  href="https://solscan.io/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Solscan
                </a>{" "}
                or{" "}
                <a
                  href="https://explorer.solana.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Solana Explorer
                </a>
                . After a trade, you can check your transaction history
                directly on-chain for full transparency.
              </>
            ),
          },
        ],
        callout: {
          variant: "warn",
          align: "center",
          icon: "warn",
          content: (
            <>
              <strong>Remember!</strong> Self-custody means accountability.
              There is no "reset password" button in DeFi. Stay cautious, move
              deliberately, and you will trade with confidence.
            </>
          ),
        },
      },
      {
        title: "Next steps for Solana beginners",
        paragraphs: [
          "Now that you understand how Solana DEXs work, the best way to learn is by doing and, ideally, start small.",
          <>
            Begin with a <strong>small swap</strong>, even just a few dollars'
            worth of SOL to USDC, to get comfortable with the process. Explore a
            swap aggregator like <strong>Jupiter</strong> to see how it
            automatically finds the best price across platforms.
          </>,
          <>
            As you grow more comfortable, you can gradually explore features
            like{" "}
            <a
              href="https://solana.com/learn/what-is-staking"
              target="_blank"
              rel="noreferrer"
            >
              staking
            </a>{" "}
            or providing <strong>liquidity</strong>, but there's no rush.
          </>,
          "In DeFi, progress happens step by step. Small, thoughtful actions build real understanding.",
        ],
      },
      {
        title: "Solana DEX: where speed meets self-custody",
        paragraphs: [
          "Solana DEXs combine speed, affordability, and self-custody into one powerful trading experience. You stay in control of your funds, trades settle in seconds, and fees remain minimal, which makes it an ideal environment for beginners.",
          "By starting small and learning how swaps, liquidity, and fees work, you're building real DeFi skills that extend far beyond Solana. Every transaction helps you better understand how decentralized finance operates.",
          <>
            <strong>The best way to gain confidence is simple: take action.</strong>{" "}
            Your first swap is just a few clicks away, and it might be the start
            of your DeFi journey.
          </>,
        ],
      },
      {
        title: "Solana DEXs FAQ",
        type: "faq",
        items: [
          {
            question: "What is the best Solana DEX for beginners?",
            answer:
              "For most Solana beginners, Jupiter and Orca are the best starting points. Jupiter automatically finds the best price across multiple platforms, while Orca offers a clean, easy-to-follow interface.",
          },
          {
            question: "Are Solana DEXs safe to use?",
            answer:
              "Solana DEXs are 100% secure if you use them correctly, but remember that they operate under self-custody rules. As there are no intermediaries, you are fully responsible for protecting your wallet, and transactions are irreversible.",
          },
          {
            question: "Can I use my MetaMask wallet on Solana?",
            answer:
              "Yes. MetaMask offers native Solana support in its browser extension, enabling you to connect directly to Solana DEXs and manage SOL within your wallet.",
          },
          {
            question: "What are the fees on a Solana DEX?",
            answer:
              "Solana network fees are typically just fractions of a cent. Most Solana DEX trading fees remain under 1%, making it one of the most cost-effective ecosystems for beginners.",
          },
          {
            question: "What is slippage on a Solana DEX?",
            answer:
              "Slippage is the difference between the expected price of a trade and the price you actually get it. On Solana, fast confirmations and strong liquidity often help reduce slippage compared to slower networks.",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    difficulty: "Easy",
    title: "How to Use Phantom Wallet (2026): Beginner’s Step-by-Step Guide",
    text:
      "Learn how to set up, secure, and use Phantom Wallet in 2026. Step-by-step beginner tutorial for sending crypto, connecting dApps, and managing NFTs safely.",
    detailSubtitle:
      "How to Use Phantom Wallet (2026): Beginner’s Guide To Sending, Receiving, and Storing Crypto",
    image: phantomDownload,
    heroImage: phantomDownload,
    time: "11 min",
    date: "2026-02-18",
    categories: ["Wallets", "Security", "Blockchain", "Fees"],
    sections: [
      {
        title: "Phantom wallet for beginners: key takeaways",
        list: [
          {
            content: (
              <>
                <strong>Multi-chain support:</strong> Built for Solana, but
                works great with Ethereum, Bitcoin, Polygon, Base, Sui, and
                more.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Beginner-friendly:</strong> Easy setup with seedless
                login; recovery phrase option for advanced users.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Built-in security:</strong> Transaction previews, scam
                detection, spam token filtering, optional hardware wallet.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Quick transactions:</strong> Send, receive, swap, and
                manage NFTs safely.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>dApp connections:</strong> Start with trusted platforms,
                build trust as you learn.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Advanced features:</strong> Staking SOL/PSOL, cross-chain
                swaps, multiple accounts, NFT/Ordinals support.
              </>
            ),
          },
        ],
      },
      {
        title: "Introduction",
        paragraphs: [
          {
            text: "How to Use Phantom Wallet (2026): Beginner’s Guide To Sending, Receiving, and Storing Crypto",
            variant: "lead",
          },
          "At some point, almost every crypto beginner hits the same realization: you buy your first tokens on an exchange… and then notice you don’t fully control them. That’s when a crypto wallet becomes essential.",
          "A wallet isn’t where your crypto “sits.” Think of it as a key that gives you access to your assets on the blockchain. It lets you send, receive, and use crypto without relying on an intermediary to hold it for you.",
          <>
            In our{" "}
            <a
              href="https://www.coinporate.com/academy/solana-beginner-tutorial-2026-wallets-dexs-staking-first-steps-safety"
              target="_blank"
              rel="noreferrer"
            >
              previous guide
            </a>
            , we showed you how to set up a MetaMask wallet. This time, we zoom
            in on another popular crypto beginner’s choice: Phantom.
          </>,
          <>
            Originally built for the Solana ecosystem, Phantom has grown from
            3.2 million monthly users in early 2024 to{" "}
            <a
              href="https://coinlaw.io/phantom-wallet-statistics"
              target="_blank"
              rel="noreferrer"
            >
              15+ million in 2025
            </a>
            . In that year alone, users processed 850 million transactions,
            highlighting its widespread adoption.
          </>,
          "The best part? Despite its scale, Phantom is easy to set up and beginner-friendly. In this guide, you’ll learn how it works, how to set it up safely, and how to make your first transaction with confidence.",
        ],
      },
      {
        title: "What is a Phantom Wallet?",
        paragraphs: [
          "Phantom Wallet is an app that lets you securely store, manage, and use crypto across multiple blockchains–all from one place.",
          "If you’re just starting out, the word “wallet” can be a bit misleading. Unlike a physical wallet, Phantom doesn’t hold your money.",
          "Think of it as a digital safe: it gives you full control over your crypto, and only you have the keys to open it.",
          "Here are the three key things to know about Phantom:",
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Self-custodial:</strong> Your funds are truly yours. No
                bank or exchange can move them without your permission.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Multi-chain:</strong> While built for Solana, Phantom
                supports Ethereum, Bitcoin, Polygon, Base, Sui, and more–all in
                one app.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Wallet, not an exchange:</strong> Phantom is where you
                manage your assets. You can connect to exchanges or
                decentralized apps (dApps), but it acts as your personal gateway
                to the blockchain.
              </>
            ),
          },
        ],
      },
      {
        title: "How Phantom wallet works",
        paragraphs: [
          "Understanding a crypto wallet gets easier once you find everyday analogies:",
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Wallet = digital safe dashboard:</strong> Phantom shows
                your crypto assets and lets you control them, but they actually
                “sit” in the blockchain.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Wallet address = public mailbox:</strong> This address
                allows you to receive crypto. Anyone can see it on the
                blockchain, but it can’t move funds without your keys.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Private key/recovery phrase = your master key:</strong>{" "}
                Grants full access to your funds. Keep it safe, as anyone who
                gets their hands on it can spend your crypto.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Crypto assets live on the blockchain:</strong> Phantom
                simply displays them, letting you send, receive, and interact
                with apps.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Network fees = tips for validators:</strong> Small fees
                go to blockchain validators to confirm your transactions, much
                like tipping your waiting staff at a café.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Transactions are irreversible:</strong> Once confirmed,
                you can’t undo them–like posting a traditional letter. Always
                double-check addresses and amounts before sending.
              </>
            ),
          },
        ],
      },
      {
        title: "Reasons crypto beginners love Phantom",
        paragraphs: [
          "Phantom makes getting started with crypto simple and approachable:",
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Clean, intuitive interface:</strong> Quickly check
                balances, send and receive crypto, and explore the wallet
                without getting confused. You can start using the wallet right
                after installing it on your desktop or mobile.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>No technical skills needed:</strong> Phantom handles
                all complex stuff for you! Automatic network handling means you
                don’t need to manually switch blockchains when sending tokens or
                using apps.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Built-in swaps:</strong> Exchange one token for another
                directly in the wallet without having to jump to an exchange
                every time.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>NFT support:</strong> View, manage, and track
                collectibles in one place. Phantom flags suspicious tokens and
                addresses in real time to help you avoid scams.
              </>
            ),
          },
        ],
        tailParagraphs: [
          "In a nutshell, Phantom gives beginners a safe, user-friendly way to explore and manage crypto across multiple blockchains, making it a top choice for first-time wallet users.",
        ],
      },
      {
        title: "How to use Phantom wallet: step by step tutorial",
        ordered: true,
        listVariant: "steps",
        list: [
          {
            title: "Download Phantom wallet from official sources",
            details: [
              {
                text: "Download the wallet from the official website or trusted app stores. Fake apps do exist, and installing the wrong one can put your funds at risk.",
              },
              {
                text: "Make sure you double-check the URL and publisher name before installing anything on your device–this simple step prevents many beginner mistakes.",
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: phantomDownload,
                  alt: "Phantom download page",
                },
              },
            ],
          },
          {
            title: "Choose your Phantom wallet setup type",
            details: [
              {
                text: "When you open Phantom on your desktop or device, you choose how to create your wallet:",
              },
              {
                content: (
                  <>
                    <strong>Seedless login (email + PIN):</strong> Easy setup
                    and recovery is great for beginners.
                  </>
                ),
              },
              {
                content: (
                  <>
                    <strong>Recovery phrase wallet:</strong> Traditional setup
                    using a secret phrase you must store yourself.
                  </>
                ),
              },
              {
                content: (
                  <>
                    <strong>Safety recommendation:</strong>{" "}
                    <strong>Beginners →</strong> it’s best to choose seedless
                    login for simplicity. It ensures you can restore access.{" "}
                    <strong>More advanced wallet users →</strong> consider a
                    recovery phrase wallet for maximum control, and keep it
                    safely offline.
                  </>
                ),
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: phantomSetup,
                  alt: "Phantom wallet setup options",
                },
              },
            ],
          },
          {
            title: "Secure your wallet",
            details: [
              {
                text: "If you go for a recovery phrase, treat it like a master key:",
              },
              {
                text: "Never screenshot or store it in cloud notes!",
              },
              {
                text: "Don’t share it with anyone.",
              },
              {
                text: "Ideally, write it down in hand and keep it offline in a safe place.",
              },
            ],
          },
          {
            title: "Explore your Phantom wallet’s interface",
            details: [
              {
                text: "Take a moment to get familiar with the wallet:",
              },
              {
                content: (
                  <>
                    <strong>Balance:</strong> Your crypto holdings;
                  </>
                ),
              },
              {
                content: (
                  <>
                    <strong>Send / Receive:</strong> Move crypto in or out;
                  </>
                ),
              },
              {
                content: (
                  <>
                    <strong>Swap:</strong> Exchange tokens inside the app;
                  </>
                ),
              },
              {
                content: (
                  <>
                    <strong>Collectibles:</strong> View NFTs and digital assets;
                  </>
                ),
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: phantomHome,
                  alt: "Phantom wallet home screen",
                },
              },
            ],
          },
          {
            title: "Fund your wallet",
            details: [
              {
                text: "You can buy crypto directly inside Phantom or transfer funds from an exchange.",
              },
              {
                content: (
                  <>
                    <strong>
                      Always double-check that the network matches when sending
                      crypto: if you use the wrong network, your loss can be
                      permanent.
                    </strong>
                  </>
                ),
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: phantomBuySol,
                  alt: "Buying SOL in Phantom",
                },
              },
            ],
          },
          {
            title: "Get ready for your first transactions",
            details: [
              {
                text: "Now that your Phantom Wallet is set up and funded, it’s time to try your first transaction. Remember: always start small. Testing with insignificant amounts is the best way to learn without risk.",
              },
              {
                text: "1.Receive a small amount",
              },
              {
                text: "Click Receive in your wallet and copy your wallet address or share the QR code:",
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: phantomReceive,
                  alt: "Phantom receive address screen",
                },
              },
              {
                text: "Send a very small amount of crypto from an exchange, friend, or another wallet. This ensures everything works before you move larger sums.",
              },
              {
                text: "2.Send a test transaction",
              },
              {
                text: "Once the funds arrive, select Send, paste a recipient address (even your own secondary wallet for practice), and enter a tiny amount.",
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: phantomSend,
                  alt: "Phantom send screen",
                },
              },
              {
                content: (
                  <>
                    <strong>
                      Always double-check the address and network before
                      confirming!
                    </strong>
                  </>
                ),
              },
              {
                text: "3.Check transaction history",
              },
              {
                text: "After sending, check your transaction history in Phantom. Confirm that the transfer shows as completed and that balances are updated correctly.",
              },
              {
                text: "If everything looks correct, congrats! You’ve completed your first transaction safely.",
              },
            ],
          },
        ],
      },
      {
        title: "How to connect Phantom wallet to dApps",
        paragraphs: [
          <>
            Decentralized applications, also known as dApps, are websites or
            platforms that run on blockchain networks instead of centralized
            servers. (Read on differences between{" "}
            <a
              href="https://www.geeksforgeeks.org/ethical-hacking/centralized-vs-decentralized-applications/"
              target="_blank"
              rel="noreferrer"
            >
              centralized vs. decentralized apps
            </a>
            ).
          </>,
          <>
            DApps let you trade, stake, or interact with crypto in ways
            conventional, centralized apps can’t. Examples include{" "}
            <a
              href="https://app.uniswap.org/"
              target="_blank"
              rel="noreferrer"
            >
              Uniswap
            </a>{" "}
            or{" "}
            <a
              href="https://pancakeswap.finance/"
              target="_blank"
              rel="noreferrer"
            >
              Pancake Swap
            </a>{" "}
            for token swaps and{" "}
            <a href="https://opensea.io/" target="_blank" rel="noreferrer">
              OpenSea
            </a>{" "}
            for buying, selling, or managing NFTs.
          </>,
          "When you connect Phantom to a dApp, you’re granting it permission to view your wallet balance and, in some cases, initiate transactions. A popup will appear asking you to confirm the connection. Always read it carefully before clicking “Connect.”",
          {
            text: "Always read the permissions carefully — don’t blindly click “Connect.”",
            variant: "strong",
          },
          "You can disconnect dApps anytime via Phantom’s Connected Apps section or directly from the dApp itself. For safety, consider disconnecting immediately after use and periodically reviewing which dApps have access to your wallet.",
          {
            variant: "block",
            content: (
              <div className="academy-detail-block__image academy-detail-block__image--step">
                <img
                  src={phantomConnect}
                  alt="Phantom connection approval"
                />
              </div>
            ),
          },
        ],
        listTitle: "⚠️ Beginner dApp Safety Checklist:",
        listVariant: "checklist",
        list: [
          "Start small: Test new dApps with tiny amounts of crypto first.",
          "Use trusted platforms first: Stick to well-known dApps before experimenting with larger amounts.",
          "Check permissions: Read every popup carefully before connecting your wallet. Know what access the dApp is requesting.",
          "Disconnect after use: Remove access from Phantom’s Connected Apps section or directly via the dApp.",
          "Watch for red flags: Avoid unknown websites, urgent popups, or promises that seem too good to be true.",
        ],
        tailParagraphs: [
          "💡 Following these steps helps you explore the decentralized web safely while keeping your crypto secure.",
        ],
      },
      {
        title: "Is Phantom wallet secure?",
        paragraphs: [
          "The short answer: Yes! Phantom offers strong protections, but because it’s a self-custodial wallet, the safety of your crypto ultimately depends on how well you manage your keys and interactions.",
        ],
        listTitle: "The 3 biggest risks for Phantom wallet beginners",
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Phishing:</strong> Scammers create fake websites that
                look like Phantom or popular dApps. Clicking these links can
                expose your private keys or seed phrases.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Fake support accounts:</strong> No legitimate support
                teams ask for your recovery phrase. Beware of social media
                accounts or messages claiming to help you recover funds.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Signing bad transactions:</strong> Avoid approving
                malicious transactions that can drain your wallet. Always check
                the details before you confirm anything.
              </>
            ),
          },
        ],
      },
      {
        title: "Phantom’s built-in protections",
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Transaction Preview</strong> shows exactly what you’re
                sending, including amounts, addresses, and network fees.
              </>
            ),
            media: {
              type: "image",
              src: phantomConfirm,
              alt: "Phantom transaction confirmation",
            },
          },
          {
            content: (
              <>
                <strong>Scam Detection</strong> uses machine learning to flag
                suspicious addresses and potential risks.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Spam Token Filtering</strong> automatically hides fake
                or misleading tokens from your view.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Device Authentication:</strong> use your device’s PIN
                or biometrics for extra protection.
              </>
            ),
            media: {
              type: "image",
              src: phantomSecurity,
              alt: "Phantom security and privacy settings",
            },
          },
        ],
      },
      {
        title: "Phantom wallet security: beginner’s checklist",
        listVariant: "checklist",
        list: [
          "Never share your recovery phrase or private keys. Keep them offline in a secure location.",
          "Verify URLs before connecting to any dApp or site.",
          "Use biometrics on your device: Face ID or fingerprint for additional protection.",
          "Consider a hardware wallet later if you plan to store large amounts of crypto.",
        ],
        tailParagraphs: [
          "By following these precautions in Phantom, you gain a powerful and safe way to manage crypto across multiple blockchains.",
          "Taking a few extra moments to double-check links, transactions, and permissions can prevent costly mistakes and make your crypto journey much safer.",
        ],
      },
      {
        title: "Advanced Phantom wallet features",
        paragraphs: [
          "Once you’re comfortable with the basics, Phantom offers some advanced features so you can get more out of your wallet:",
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Cross-chain swaps:</strong> Swap tokens between
                supported blockchains directly in Phantom without using an
                external exchange.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Staking SOL / PSOL:</strong> Earn rewards by staking
                your Solana (SOL) tokens. Phantom even offers PSOL, a liquid
                staking token you can use elsewhere while earning yield. Read
                more about staking in{" "}
                <a
                  href="https://help.phantom.com/hc/en-us/sections/4406351831571-Staking"
                  target="_blank"
                  rel="noreferrer"
                >
                  this official Phantom documentation
                </a>
                .
              </>
            ),
          },
          {
            content: (
              <>
                <strong>NFT &amp; Ordinals Support:</strong> View, manage, and
                sell NFTs directly in your wallet. For Bitcoin users, Phantom
                also supports Ordinals, letting you track and manage rare
                satoshis.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Multiple Accounts:</strong> Create separate accounts
                for different purposes (trading, NFTs, savings) for better
                organization and security.
              </>
            ),
          },
        ],
        tailParagraphs: [
          {
            text: "💡 Tip for Beginners: Treat all these options as “things to explore once you’re comfortable.” Start small, and only try new features once you understand the basics of sending, receiving, and securing crypto.",
            variant: "highlight",
          },
        ],
      },
      {
        title: "Your first Phantom wallet: final thoughts",
        paragraphs: [
          "Starting to use a Phantom wallet doesn’t have to be overwhelming.",
          <>
            <strong>Begin small,</strong> sending and receiving tiny amounts to
            learn the transaction flow and understand how the wallet works.
            Take your time to explore one dApp or feature at a time, be it for
            swaps, NFTs, or staking.
          </>,
          <>
            <strong>Always put security first:</strong> keep your recovery
            phrase offline, enable biometrics, and double-check addresses before
            sending crypto. By building safe habits early, you gain confidence
            for larger transactions.
          </>,
        ],
        tailParagraphs: [
          {
            text: "💡 Remember: this guide is for educational purposes only. Cryptocurrency is volatile, and only you are responsible for your funds. Start carefully, learn steadily, and build solid foundation for safe, confident crypto management.",
            variant: "strong",
          },
        ],
      },
      {
        title: "Phantom wallet for beginners FAQ",
        type: "faq",
        items: [
          {
            question: "Is Phantom wallet trustworthy?",
            answer: [
              <>
                Yes. Phantom is a{" "}
                <strong>multichain, non-custodial wallet</strong>, meaning you
                control your keys without relying on a third party. It works on
                both desktop and mobile and is beginner-friendly, whether you’re
                sending BTC, minting NFTs, or exploring dApps.
              </>,
              "That said, security ultimately depends on safely storing your seed phrase, which remains a single point of failure.",
            ],
          },
          {
            question: "Is Phantom wallet safe?",
            answer:
              "Yes! Phantom includes built-in protections like transaction previews, scam detection, and spam token filtering. But as it is self-custodial, you are responsible for keeping your recovery phrase and private keys secure.",
          },
          {
            question: "Is Phantom free to use?",
            answer:
              "Yes! Downloading and using Phantom is completely free. You only pay network fees when sending, receiving, or swapping crypto.",
          },
          {
            question: "Can I recover my Phantom wallet?",
            answer: [
              <strong>Wallet recovery depends on your setup:</strong>,
              <>
                <strong>Seedless login:</strong> Use your email + PIN.
              </>,
              <>
                <strong>Recovery phrase wallet:</strong> Use your 12-word
                recovery phrase.
              </>,
              <>
                <strong>Imported wallet:</strong> Use the original seed phrase
                or private key.
              </>,
              <>
                <strong>Never share these credentials:</strong> they are the
                only way to restore access!
              </>,
            ],
          },
          {
            question: "Can I use Phantom wallet to store NFTs?",
            answer:
              "Absolutely! Phantom allows you to view, manage, and sell NFTs across supported blockchains, including Solana and Ethereum. It even tracks NFT metadata and marketplace offers for smoother management.",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    difficulty: "Easy",
    title:
      "Solflare Wallet: The Ultimate Beginner’s Guide (2026 Tutorial, Review & Solflare vs Phantom)",
    text: "Learn how to set up your first Solflare wallet in 2026 with our beginner step-by-step tutorial, security tips, and a Solflare vs Phantom comparison for Solana.",
    detailSubtitle:
      "Learn how to set up your first Solflare wallet in 2026 with our beginner step-by-step tutorial, security tips, and a Solflare vs Phantom comparison for Solana.",
    image: solflareDownload,
    heroImage: solflareHeroBanner,
    time: "12 min",
    date: "2026-02-25",
    categories: ["Wallets", "Security", "Blockchain", "Staking"],
    sections: [
      {
        title: "Solflare wallet for beginners: key takeaways",
        list: [
          {
            content: (
              <>
                <strong>Solflare is a Solana-native wallet</strong> that lets
                you store, stake, swap, and manage tokens and NFTs in one place.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Solflare wallet is non-custodial:</strong> you remain
                fully responsible for securing your recovery phrase and
                Solflare can’t recover your private keys or funds if you lose
                them.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>The wallet is beginner-friendly</strong> while
                providing access to advanced tools such as validator selection
                and staking analytics.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>
                  Solflare is best suited for users focused on the Solana
                  ecosystem
                </strong>{" "}
                through DeFi, staking, or NFT activities.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Most Solflare security risks</strong> are user-side
                (phishing, fake websites, or losing recovery phrases) rather
                than due to the wallet’s internal infrastructure.
              </>
            ),
          },
        ],
      },
      {
        title: "Introduction",
        paragraphs: [
          "Have you ever wondered how people manage their crypto without relying on banks or centralized platforms?",
          "If you are exploring cryptocurrency, you’ll quickly realize that choosing the right wallet is just as important as deciding which coins to hold.",
          "As more users move toward decentralized finance, wallets have become the primary tool for interacting with the crypto world.",
          "The rapid growth of the Solana blockchain has also increased demand for fast, simple, and mobile-friendly wallets. With millions of transactions processed across the network every day, users need lightweight tools to access trading platforms, NFT marketplaces, staking opportunities, and more.",
          <>
            <strong>
              That’s where the{" "}
              <a
                href="https://www.solflare.com/"
                target="_blank"
                rel="noreferrer"
              >
                Solflare wallet
              </a>{" "}
              comes in.
            </strong>
          </>,
          "Designed to be your everyday crypto companion, Solflare is your personal gateway into the Solana ecosystem. It allows users to manage crypto, stake tokens, and explore decentralized applications in one place.",
          <>
            This guide walks you through everything you need to know to get
            started, from wallet setup to security practices and comparison
            with{" "}
            <a
              href="https://www.coinporate.com/academy/how-to-use-phantom-wallet-2026-beginner-s-step-by-step-guide"
              target="_blank"
              rel="noreferrer"
            >
              another popular wallet
            </a>
            .
          </>,
          "By the end, you should feel more confident taking your first steps into Solana, even if you are completely new to crypto.",
        ],
      },
      {
        title: "What is Solflare?",
        paragraphs: [
          <>
            Solflare is a <strong>non-custodial wallet</strong> built for the
            Solana blockchain that allows users to store, stake, swap, and
            manage tokens and NFTs.
          </>,
          "The wallet’s growth reflects the broader adoption of Solana’s high-speed, low-fee blockchain architecture, which attracts both casual users and advanced traders.",
          <>
            By{" "}
            <a
              href="https://coinlaw.io/solflare-wallet-statistics/"
              target="_blank"
              rel="noreferrer"
            >
              <strong>mid-2025</strong>
            </a>
            , Solflare was estimated to have more than{" "}
            <strong>4 million active users</strong> managing roughly{" "}
            <strong>$8.5 billion in assets</strong>.
          </>,
          "The wallet is available as a browser extension and mobile application, offering a simple interface for everyday crypto use.",
        ],
        callout: {
          variant: "warn",
          align: "center",
          icon: "warn",
          content: (
            <>
              <strong>Non-custodial wallets:</strong>{" "}
              <strong>
                This wallet type ensures that you remain in full control of the
                assets and private keys to your funds.
              </strong>{" "}
              No company or third party holds your funds, which means security
              depends largely on how well you protect your recovery phrase. If
              you lose access to your keys, recovery is usually impossible.
            </>
          ),
        },
      },
      {
        title: "What are the key features of Solflare?",
        paragraphs: [
          "Solflare wallet isn’t just a place to store SOL and other Solana tokens, but a full-service gateway into the Solana ecosystem. Here’s what you can do with it:",
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Fiat on-ramps:</strong> Buy crypto directly inside the
                app through third-party payment providers, which may include
                debit/credit cards, bank transfers, Apple Pay, or Google Pay.
                This feature makes getting started much easier for beginners
                without crypto assets.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Built-in trading:</strong> Instantly swap between SOL
                and other Solana-based tokens without leaving the wallet.
                Advanced users can adjust slippage settings, place limit orders
                (where supported), and preview transactions before confirming.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Send and receive assets:</strong> Solflare wallet
                supports SOL, SPL tokens, and Solana NFTs. Every transaction
                includes a confirmation screen with clear details to support
                users in understanding what they are approving before signing.
              </>
            ),
          },
        ],
      },
      {
        title: "Solana-native features",
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>Native SOL staking:</strong> Choose validators,
                delegate SOL, and earn staking rewards directly from the
                wallet. There’s also an instant un-stake option through
                supported providers, together with the standard cooldown-based
                un-staking process.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>dApp connectivity:</strong> Connect to Solana dApps such
                as decentralized exchanges, DeFi protocols, NFT marketplaces,
                prediction markets, or blockchain games in one click.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Portfolio dashboard:</strong> A unified dashboard
                showing token balances, staked SOL, NFTs, and DeFi positions.
                Real-time fiat values and built-in Profit &amp; Loss tracking
                enable you to monitor performance over time.
              </>
            ),
          },
        ],
      },
      {
        title: "What makes Solflare different from other Solana wallets?",
        paragraphs: [
          "One of Solflare’s main advantages is its deep integration with the Solana blockchain.",
          <>
            Unlike <strong>multi-chain wallets</strong> that support several
            networks, Solflare focuses primarily on Solana. This allows tighter
            optimization for SOL staking, SPL token management, NFT activity,
            and Solana-native DeFi applications.
          </>,
        ],
      },
      {
        title: "Solflare vs Phantom: a quick comparison",
        paragraphs: [
          <>
            When comparing{" "}
            <strong>
              Solflare vs{" "}
              <a
                href="https://www.coinporate.com/academy/how-to-use-phantom-wallet-2026-beginner-s-step-by-step-guide"
                target="_blank"
                rel="noreferrer"
              >
                Phantom
              </a>
            </strong>
            , you’re choosing between two of the most popular ways to access
            the Solana ecosystem.
          </>,
          "Here’s a quick breakdown of the differences between these two Solana wallets:",
        ],
        type: "table",
        columns: ["Feature", "Solflare", "Phantom"],
        rows: [
          [
            <strong>Blockchain networks &amp; focus</strong>,
            <>
              <strong>Solana-focused</strong> and optimized for SOL staking,
              NFTs, and Solana DeFi tools.
            </>,
            <>
              <strong>Multi-chain support</strong>: apart from Solana, it also
              supports Ethereum, Bitcoin, Polygon, Base, and more.
            </>,
          ],
          [
            <strong>User experience</strong>,
            "Approachable, yet feature-rich interface suited to the needs of users needing more detailed staking and validator options.",
            "Sleek, beginner-friendly design with strong NFT presentation and intuitive navigation.",
          ],
          [
            <strong>SOL staking &amp; advanced tools</strong>,
            "Advanced staking options with validator selection and analytics. Noticeable strong Solana-native integrations.",
            "Simplified staking experience designed for speed and ease of use.",
          ],
        ],
        callout: {
          variant: "frame",
          align: "center",
          content: (
            <>
              <strong>Solflare vs Phantom: which one should I choose?</strong>
              <ul>
                <li>
                  <strong>Beginners</strong> may prefer Phantom’s simpler
                  design.
                </li>
                <li>
                  <strong>Heavy traders</strong> may appreciate Phantom’s
                  multi-chain flexibility.
                </li>
                <li>
                  <strong>NFT collectors and DeFi users</strong> may benefit
                  from Solflare’s detailed dashboards and validator selection
                  tools.
                </li>
              </ul>
            </>
          ),
        },
      },
      {
        title: "Is Solflare safe?",
        paragraphs: [
          "Like most crypto wallets, security concerns usually come from user behavior rather than infrastructure vulnerabilities.",
          <>
            As of{" "}
            <a
              href="https://www.solflare.com/crypto-101/securing-your-solflare-crypto-wallet-best-practices/"
              target="_blank"
              rel="noreferrer"
            >
              2026
            </a>
            , there are no widely confirmed reports of major breaches directly
            targeting Solflare’s internal systems.
          </>,
          "Most reported losses in the ecosystem are caused by phishing attacks, social engineering, or fake websites rather than wallet software failures.",
          {
            text: "Security features inside the wallet include:",
            variant: "underline",
          },
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>clear transaction signing prompts;</strong>
              </>
            ),
          },
          {
            content: (
              <>
                <strong>
                  built-in transaction simulations to detect potentially risky
                  interactions;
                </strong>
              </>
            ),
          },
          {
            content: (
              <>
                <strong>
                  Solflare Guards, a system designed to flag suspicious
                  activity.
                </strong>
              </>
            ),
          },
        ],
        tailParagraphs: [
          <>
            Solflare also supports hardware wallets like{" "}
            <a
              href="https://www.coinporate.com/academy/solana-beginner-tutorial-2026-wallets-dexs-staking-first-steps-safety"
              target="_blank"
              rel="noreferrer"
            >
              Ledger
            </a>
            , and is compatible with Solflare Shield, a Solana-native NFC
            hardware wallet for mobile-first cold storage.
          </>,
        ],
      },
      {
        title: "Setting up Solflare wallet: step-by-step tutorial",
        paragraphs: [
          <>
            If you’re ready to try the <strong>Solflare wallet</strong>, this
            guide will walk you through all the steps from download to staking.
          </>,
        ],
        ordered: true,
        listVariant: "steps",
        list: [
          {
            title: "Download & install Solflare",
            details: [
              {
                text: "First, download the official version of the Solflare wallet. Always access the wallet through the official website or verified app stores. Avoid clicking links from ads, social media DMs, or emails: phishing sites often imitate real wallet pages.",
              },
              {
                content: <strong>You get three options:</strong>,
              },
              {
                content: (
                  <>
                    <strong>Web Wallet:</strong> Access directly through your
                    browser without installing anything.
                  </>
                ),
              },
              {
                content: (
                  <>
                    <strong>Browser Extension:</strong> Ideal for interacting
                    with dApps on desktop (similar to MetaMask-style use).
                  </>
                ),
              },
              {
                content: (
                  <>
                    <strong>Mobile App (iOS & Android):</strong> Great for
                    managing assets on the go.
                  </>
                ),
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: solflareDownload,
                  alt: "Solflare download options",
                },
              },
            ],
          },
          {
            title: "Create a New Wallet",
            details: [
              {
                content: (
                  <>
                    Once installed, open the app and select{" "}
                    <strong>“Create New Wallet.”</strong>
                  </>
                ),
              },
              {
                text: "You’ll be prompted to set a strong password. This password protects access on the device, but it’s not yet your recovery key. Choose something unique and store it securely.",
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: solflareCreateWallet,
                  alt: "Create a new Solflare wallet",
                },
              },
            ],
          },
          {
            title: "Secure your wallet with the Solflare Recovery Phrase",
            details: [
              {
                content: (
                  <>
                    The most important step is securing your{" "}
                    <strong>Solflare Recovery Phrase</strong>.
                  </>
                ),
              },
              {
                text: "This is a 12 or 24-word phrase that acts as the master key to your wallet. If you lose your device, this phrase is the only way to restore access. If someone else gets it, they can access your funds.",
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: solflareRecoveryPhrase,
                  alt: "Solflare recovery phrase screen",
                },
              },
              {
                variant: "block",
                content: (
                  <div className="academy-detail-callout academy-detail-callout--frame">
                    <div className="academy-detail-callout__text">
                      <strong>
                        ⚠️ Tips for keeping your Solflare Recovery Phrase safe ⚠️
                      </strong>
                      <div>
                        <strong>Store it safely:</strong>
                      </div>
                      <ul>
                        <li>Write it down on paper.</li>
                        <li>Keep it offline.</li>
                        <li>Consider using a hardware backup solution.</li>
                      </ul>
                      <div>
                        <strong>Never:</strong>
                      </div>
                      <ul>
                        <li>Screenshot it.</li>
                        <li>Store it in email or cloud notes.</li>
                        <li>
                          Share it with anyone, including Solflare wallet
                          “support.”
                        </li>
                      </ul>
                    </div>
                  </div>
                ),
              },
            ],
          },
          {
            title: "Adding funds to Solflare",
            details: [
              {
                content: (
                  <>
                    To start using your wallet, you’ll need SOL. Tap{" "}
                    <strong>“Receive”</strong> to view your wallet address: a
                    long string of characters unique to you. Copy it carefully.
                  </>
                ),
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: solflareReceive,
                  alt: "Solflare receive address",
                },
              },
              {
                text: "Remember that Solflare only works with Solana assets, so you won’t be able to receive assets from other networks.",
              },
              {
                text: "If you send SOL from an exchange, paste that address into the withdrawal section of the exchange and confirm the transfer. Always double-check the first and last characters before sending.",
              },
              {
                text: "You can also buy crypto directly from the wallet.",
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: solflareBuyCrypto,
                  alt: "Buy crypto in Solflare",
                },
              },
            ],
          },
          {
            title: "Using Solflare with dApps",
            details: [
              {
                text: "One of the key advantages of Solflare is its seamless connectivity with dApps.",
              },
              {
                content: (
                  <>
                    When visiting platforms like Raydium, Orca, or Magic Eden,
                    just click <strong>“Connect Wallet”</strong> and choose
                    Solflare.
                  </>
                ),
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: solflareHero,
                  alt: "Connect Solflare to a dApp",
                },
              },
              {
                text: "You’ll receive a pop-up asking you to approve the connection. Always review permissions before confirming.",
              },
            ],
          },
          {
            title: "Staking SOL with Solflare",
            details: [
              {
                variant: "block",
                content: (
                  <div className="academy-detail-block__list-group">
                    <p className="academy-detail-block__step-paragraph">
                      Staking allows you to earn rewards by helping to secure
                      the Solana network.
                    </p>
                    <p className="academy-detail-block__paragraph academy-detail-block__paragraph--strong">
                      Benefits include:
                    </p>
                    <ul className="academy-detail-block__step-details">
                      <li>Passive rewards;</li>
                      <li>Supporting network decentralization;</li>
                      <li>No need to run technical infrastructure.</li>
                    </ul>
                    <p className="academy-detail-block__paragraph academy-detail-block__paragraph--underline">
                      How to stake:
                    </p>
                    <ol className="academy-detail-block__step-details academy-detail-block__step-details--ordered">
                      <li>Open the Staking section.</li>
                      <li>Choose a validator.</li>
                      <li>Enter the amount of SOL to delegate.</li>
                      <li>Confirm the transaction.</li>
                    </ol>
                    <p className="academy-detail-block__step-paragraph">
                      Rewards accumulate over time and can be tracked in your
                      dashboard.
                    </p>
                  </div>
                ),
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: solflareStaking,
                  alt: "Staking SOL with Solflare",
                },
              },
              {
                variant: "block",
                content: (
                  <div className="academy-detail-block__list-group">
                    <p className="academy-detail-block__step-paragraph">
                      What makes Solflare stand out is offering more validators
                      than just the wallet’s native one.
                    </p>
                    <p className="academy-detail-block__step-paragraph">
                      You can see the <strong>APY</strong> (Annual Percentage
                      Yield) value by each validator’s name, so you can
                      estimate your yearly return on investment.
                    </p>
                    <div className="academy-detail-callout academy-detail-callout--frame academy-detail-callout--center">
                      <div className="academy-detail-callout__text academy-detail-callout__text--center">
                        <strong>⚠️ Important notice about staking ⚠️</strong>
                        <span>
                          <strong>APY is not guaranteed</strong>, but it can
                          fluctuate depending on network conditions and
                          validator performance. Moreover, validators may take
                          a small commission, which affects your final return.
                        </span>
                      </div>
                    </div>
                  </div>
                ),
              },
            ],
          },
          {
            title: "Explore additional features of Solflare",
            details: [
              {
                text: "Solflare includes several extra tools that make it more than just a storage wallet:",
              },
              {
                content: (
                  <>
                    <strong>Token swapping:</strong> Instantly swap between SOL
                    and other Solana tokens within the wallet.
                  </>
                ),
              },
              {
                content: (
                  <>
                    <strong>NFT viewing:</strong> Browse and manage your NFT
                    collection in a built-in gallery.
                  </>
                ),
              },
              {
                content: (
                  <>
                    <strong>Transaction history:</strong> View detailed logs of
                    past transfers, staking activity, and dApp interactions.
                  </>
                ),
              },
              {
                variant: "media",
                media: {
                  type: "image",
                  src: solflareFeatures,
                  alt: "Solflare wallet features",
                },
              },
              {
                text: "With these features, Solflare becomes a complete control center for your Solana activity, no matter if you’re trading, staking, or collecting NFTs.",
              },
            ],
          },
        ],
      },
      {
        title: "How to stay safe with the Solflare wallet",
        paragraphs: [
          "Using Solflare safely isn’t complicated, but it does require a few smart habits.",
        ],
        listVariant: "body",
        list: [
          {
            content: (
              <>
                <strong>
                  Only download the wallet from the verified website or app
                  stores.
                </strong>{" "}
                Fake extensions and phishing sites are one of the most common
                ways users lose funds. Always double-check the URL before
                connecting your wallet.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Never share your recovery phrase with anyone.</strong>{" "}
                Not with friends, not with “support”.{" "}
                <strong>
                  Your recovery phrase is the master key to your funds.
                </strong>{" "}
                If someone captures it, they control your wallet.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Add extra protection with biometrics.</strong> On
                mobile, make sure to{" "}
                <strong>enable a passcode or biometric lock</strong> (Face ID
                or fingerprint) to additionally secure your wallet in case your
                phone gets lost or stolen.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Be cautious with phishing links and fake airdrops.</strong>{" "}
                If something promises free tokens but asks you to sign
                suspicious transactions, pause and verify first.
              </>
            ),
          },
          {
            content: (
              <>
                <strong>Consider getting a hardware wallet.</strong> Once you
                start holding a significant amount of crypto, consider
                connecting a <strong>hardware wallet</strong> for added
                protection. A little caution goes a long way in crypto.
              </>
            ),
          },
        ],
        tailParagraphs: [
          <>
            <strong>
              For more Solflare security tips check{" "}
              <a
                href="https://www.solflare.com/crypto-101/securing-your-solflare-crypto-wallet-best-practices/"
                target="_blank"
                rel="noreferrer"
              >
                this article
              </a>
              .
            </strong>
          </>,
        ],
      },
      {
        title: "Solflare wallet: your gateway to Solana",
        paragraphs: [
          "If deep Solana integration married with control and flexibility is what you're after, look no further than Solflare.",
          "Its focus on the Solana blockchain makes it especially powerful for users who want more than just basic storage. Whether you’re staking SOL for passive rewards, collecting NFTs, or exploring DeFi platforms, Solflare is your gateway into everything Solana has to offer.",
          "As a non-custodial wallet, it puts you in full charge of your crypto assets. At the same time, it offers practical tools like built-in staking, token swapping, NFT management, and seamless dApp connections–all without overwhelming beginners.",
          "If you’re just getting started, don’t feel pressured to use every feature at once. Begin with the basics: secure your recovery phrase, top up your wallet, and explore all features slowly.",
          "With the right security habits and a bit of curiosity, Solflare can be your first confident step into the broader world of DeFi and Web3.",
        ],
      },
      {
        title: "Solflare wallet for beginners: FAQ",
        type: "faq",
        items: [
          {
            question: "What is Solflare?",
            answer:
              "Solflare is a non-custodial wallet built for the Solana blockchain that lets you store, stake, swap, and manage tokens and NFTs while keeping full control of your private keys.",
          },
          {
            question: "How much does it cost to use Solflare?",
            answer:
              "The wallet is free to download and use, but you’ll pay small Solana network fees for transactions, staking, and token swaps.",
          },
          {
            question: "What’s the main difference between Solflare vs Phantom?",
            answer:
              "In the Solflare vs Phantom comparison, Phantom is known for its beginner-friendly design and multi-chain support, while Solflare focuses deeply on Solana and offers more detailed staking and portfolio tools.",
          },
          {
            question:
              "How do I recover my Solflare wallet if I lose my device?",
            answer:
              "You can restore access by installing the app on a new device and importing your wallet using your recovery phrase.",
          },
          {
            question: "What happens if I lose my recovery phrase?",
            answer:
              "If you lose both your device access and recovery phrase, your funds cannot be recovered. That’s why it’s essential to keep them safe.",
          },
          {
            question: "Can I use Phantom wallet to store NFTs?",
            answer: (
              <>
                Absolutely! Phantom allows you to{" "}
                <strong>view, manage, and sell NFTs</strong> across supported
                blockchains, including Solana and Ethereum. It even tracks NFT
                metadata and marketplace offers for smoother management.
              </>
            ),
          },
          {
            question: "Does Solflare support hardware wallets?",
            answer:
              "Yes. Solflare integrates with hardware wallets like Ledger and Keystone for enhanced security.",
          },
        ],
      },
    ],
  },
];

const slugify = (value) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const academyArticles = baseArticles.map((article) => ({
  ...article,
  slug: article.slug || slugify(article.title),
  heroImage: article.heroImage || heroBackground,
  detailSubtitle: article.detailSubtitle || article.text,
  sections: article.sections || defaultSections,
}));
